import React from "react";

const Education = () => (
  <section id="education" className="education">
    <h2>Education</h2>
    <br />
    <br />
    <div className="education-grid">
      <div className="edu-item">
        <h3>Bachelor of Engineering in Computer Science</h3>
        <p>The Northcap University | NCU</p>
        <p>2023-2027 | Pursuing</p>
      </div>
      <div className="edu-item">
        <br />
        <h3>High School</h3>
        <p>Shri S.N. Sidheshwar Senior Secondary Public School | CBSE</p>
        <p>2021-2023 | Completed</p>
      </div>
    </div>
  </section>
);

export default Education;